module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.display) ? _c('div', {
    staticClass: "text-center margin-top-30"
  }, [_c('h4', [_vm._v("No Results Found")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin-top"
  }, [_vm._v("There are no " + _vm._s(_vm.type) + " that match your current search criteria.")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-893c482c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/NoResults.vue
// module id = 450
// module chunks = 1